<div class="overlay-mgm d-flex h-100 flex-column">
    <div class="overlay-mgm-header">
        <button (click)="selectOverlay('user')" class="btn btn-close" type="button">
            <i class="icon icon-edponline-Bop-078 icon-2x rotate-180" aria-hidden="true"></i>
        </button>
        <div class="d-flex">
            <h2 [innerHTML]="'pt.edp.edponline.overlay-mgm.header' | translate"></h2>
        </div>
    </div>

    <div class="overlay-mgm-body flex-grow-1">
        <div class="mgm-header-body">
            <h2 [innerHTML]="'pt.edp.edponline.overlay-mgm.title' | translate"></h2>
            <p [innerHTML]="'pt.edp.edponline.overlay-mgm.text' | translate"></p>
            <img alt="" src="/assets/images/stella-images/mgm-sidebar-img.png" />
            <h3 [innerHTML]="'pt.edp.edponline.overlay-mgm.code-title' | translate"></h3>

            <p class="code-text" [innerHTML]="'pt.edp.edponline.overlay-mgm.code-text' | translate"></p>

            <div class="code-container" *ngIf="mgm?.code" (click)="copyCode(mgm?.code)">
                <span>{{ mgm.code }}</span>
                <i class="icon icon-edponline-Bas-004" aria-hidden="true"></i>
            </div>

            <div>
                <edp-e-share-buttons-mgm [codeToShare]="mgm?.code"></edp-e-share-buttons-mgm>
            </div>
        </div>
    </div>
</div>
